import React, { useState, useCallback } from 'react';
import { ErrorContext, type ErrorContextType } from './context';
import { useLogger } from '@/lib/logger';

export function ErrorProvider({ children }: { children: React.ReactNode }) {
  const [error, setErrorState] = useState<string | null>(null);
  const logger = useLogger();

  const setError = useCallback(
    (message: string) => {
      setErrorState(message);
      // Log error using logger service
      logger.error(message);
    },
    [logger]
  );

  const clearError = useCallback(() => {
    setErrorState(null);
  }, []);

  const value: ErrorContextType = {
    setError,
    clearError,
    error,
  };

  return (
    <ErrorContext.Provider value={value}>{children}</ErrorContext.Provider>
  );
}
